import type { NameIdPair } from '@/types/nameIdPair';

/**
 * Converts list of items to only NameIdPair objects based on `item.name`
 * Hereby also stripping unneeded data.
 */
export function toNameIdPairs(items: NameIdPair[]): NameIdPair[] {
    return items.map((item) => ({ _id: item._id, name: item.name }));
}
